// extracted by mini-css-extract-plugin
export default {"editActions":"styles_editActions__m3A8D","btn":"styles_btn__aNreX","loader":"styles_loader__1orSg","cancel":"styles_cancel__1KQaQ"};